import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Ornament } from "../components/Ornament";
import { storytellerDisplayName } from "../lib/storyteller";

export default function StoryWeekIntro() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [starting, setStarting] = useState(false);
  const name = storytellerDisplayName(user);
  const isSelf = !!user?.storyteller?.self_story;

  const onReady = async () => {
    setStarting(true);
    try {
      await api.post("/me/intro-seen");
      await refresh();
    } catch (_) { /* non-fatal — we'll still route on */ }
    navigate("/story-week/day/1", { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col paper-grain" style={{ background: "#FAF7F2" }} data-testid="story-week-intro-page">
      <main className="flex-1 flex items-center justify-center px-6 py-14">
        <div className="w-full max-w-xl text-center bg-[#FAF7F2] p-10 sm:p-14" style={{ borderRadius: 4 }}>
          <p className="label-ui text-[11px] text-[#B8973A] tracking-[0.35em]">✦ BEFORE YOU BEGIN ✦</p>
          <Ornament className="my-6" />
          <h1 className="text-[#111D33]"
              style={{ fontFamily: "Newsreader, 'DM Sans', sans-serif", fontWeight: 300,
                       fontSize: "clamp(2rem, 5.5vw, 2.75rem)", lineHeight: 1.2 }}
              data-testid="story-week-intro-heading">
            The Living Book works best together.
          </h1>
          <div className="mt-8 space-y-5 text-left" style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "17px", lineHeight: 1.75, color: "#1B2A4A" }}>
            {isSelf ? (
              <>
                <p>Once a week, you'll get one question. Put the kettle on, sit somewhere quiet, and press record.</p>
                <p>We'll turn what you tell us into a chapter of your Living Book — in your own words and your own voice.</p>
              </>
            ) : (
              <>
                <p>Once a week, sit down with <strong>{name || "someone you love"}</strong>. Put the kettle on, ask one question, and press record.</p>
                <p>We'll turn your conversation into a chapter of {name ? `${name}'s` : "their"} book — in {name ? `${name}'s` : "their"} own words and voice.</p>
              </>
            )}
          </div>
          <button onClick={onReady} disabled={starting}
                  className="btn-gold mt-10 w-full sm:w-auto"
                  style={{ minHeight: 52, padding: "14px 40px", fontSize: "13px", letterSpacing: "0.25em" }}
                  data-testid="story-week-intro-ready-btn">
            {starting ? "OPENING…" : "WE'RE READY"}
          </button>
        </div>
      </main>
    </div>
  );
}
